import { Star } from '@phosphor-icons/react';

interface GuestRatingFilterProps {
  value: number; // minimum rating, 0 = any
  onChange: (next: number) => void;
}

const OPTIONS: { label: string; value: number }[] = [
  { label: 'Any rating', value: 0 },
  { label: '3.5+ Pleasant', value: 3.5 },
  { label: '4.0+ Very good', value: 4 },
  { label: '4.5+ Exceptional', value: 4.5 },
];

/**
 * Guest-rating filter (client-side over loaded results — the API has no rating
 * filter yet). Single-select radio group, Booking.com style.
 */
export function GuestRatingFilter({ value, onChange }: GuestRatingFilterProps) {
  return (
    <fieldset className="border-0 p-0">
      <legend className="font-serif text-lg font-bold text-ink">Guest rating</legend>
      <ul className="mt-3 space-y-2.5">
        {OPTIONS.map((o) => (
          <li key={o.value}>
            <label className="flex cursor-pointer items-center gap-2.5 text-sm text-ink-soft">
              <input
                type="radio"
                name="guest-rating"
                checked={value === o.value}
                onChange={() => onChange(o.value)}
                className="h-4 w-4 accent-clay"
              />
              {o.value > 0 && <Star weight="fill" className="h-4 w-4 text-clay" aria-hidden="true" />}
              <span>{o.label}</span>
            </label>
          </li>
        ))}
      </ul>
    </fieldset>
  );
}
